import { Component, OnInit } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableColumn } from '@covalent/core';
import { AccountingService } from '../../../agatextscreens/accounting/accounting.service';
import { Payment } from '../../../agatextscreens/accounting/payment';
import { PaymentInvoice } from '../../../agatextscreens/accounting/payment-invoice';

import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-invoice-details-dialog',
  templateUrl: './invoice-details-dialog.component.html',
  styleUrls: ['./invoice-details-dialog.component.scss'],
  providers: [AccountingService]
})
export class InvoiceDetailsDialogComponent implements OnInit {

  invoice_id: number = 0;
  data: PaymentInvoice[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'effective_date', label: 'Date' },
    { name: 'type', label: 'Type' },
    { name: 'amount', label: 'Amount' }
  ];

  constructor(private _dialogRef: MdDialogRef<InvoiceDetailsDialogComponent>,
    private _dataTableService: TdDataTableService,
    private _accountingService: AccountingService) { }

  ngOnInit() {
    this._accountingService.getPaymentInvoices(this.invoice_id).subscribe(
      response => {
        this.data = response;
        console.log("count: " + response.length);
      },
      error => {
        console.log(error);
      }
    );
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return (Number.parseFloat(a) || 0) + (Number.parseFloat(b[field]) || 0) }, 0);
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/invoice-details-dialog/invoice-details-dialog.component.ts